import { Controller } from "@hotwired/stimulus"
import { attributedTallyUrl, browserAttribution } from "../lib/tally_attribution"

const EMBED_SCRIPT_URL = "https://tally.so/widgets/embed.js"

export default class extends Controller {
  connect() {
    this.decorate()
    this.loadEmbeds()
    this.onLink = event => {
      const link = event.target.closest("a[href]")
      if (link) this.decorateLink(link)
    }
    this.element.addEventListener("click", this.onLink, true)
    this.element.addEventListener("auxclick", this.onLink, true)
    this.observer = new MutationObserver(mutations => {
      if (!mutations.some(mutation => mutation.addedNodes.length)) return
      this.decorate()
      this.loadEmbeds()
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.removeEventListener("click", this.onLink, true)
    this.element.removeEventListener("auxclick", this.onLink, true)
  }

  decorate() {
    const fields = browserAttribution()
    this.element.querySelectorAll("a[href]").forEach(link => this.decorateLink(link, fields))
    this.element.querySelectorAll("iframe[data-tally-src]").forEach(frame => {
      // Never reload a form which may already contain the visitor's answers.
      if (frame.hasAttribute("src")) return
      const url = attributedTallyUrl(frame.dataset.tallySrc, fields)
      if (url) frame.dataset.tallySrc = url
    })
  }

  decorateLink(link, fields) {
    const url = attributedTallyUrl(link.href, fields)
    if (url) link.href = url
  }

  loadEmbeds() {
    if (!this.element.querySelector("iframe[data-tally-src]:not([src])")) return
    const load = () => {
      if (!this.element.isConnected) return
      // Pixel cookies can become available while the embed script downloads.
      this.decorate()
      if (window.Tally) {
        window.Tally.loadEmbeds()
      } else {
        this.element.querySelectorAll("iframe[data-tally-src]:not([src])").forEach(frame => {
          frame.src = frame.dataset.tallySrc
        })
      }
    }
    if (window.Tally) return load()

    let script = document.querySelector(`script[src="${EMBED_SCRIPT_URL}"]`)
    if (script?.dataset.tallyFailed === "true") return load()
    if (!script) {
      script = document.createElement("script")
      script.src = EMBED_SCRIPT_URL
      script.async = true
      script.addEventListener("error", () => { script.dataset.tallyFailed = "true" }, { once: true })
      document.head.appendChild(script)
    }
    script.addEventListener("load", load, { once: true })
    script.addEventListener("error", load, { once: true })
  }
}
